import { Form } from 'antd';

import { SCard } from 'app/components/StaycationUI';

import './Beds.scss';
import { AdditionalBeds } from './_components/AdditionalBeds';
import { BedsList } from './_components/BedsList';

export const Beds = () => (
  <SCard title="Beds">
    <Form.List name="beds">
      {(fields, { add: addBed, remove: removeBed }) => (
        <div className="beds-wrapper">
          <BedsList fields={fields} addBed={addBed} removeBed={removeBed} />
          <AdditionalBeds addBed={addBed} removeBed={removeBed} />
        </div>
      )}
    </Form.List>
  </SCard>
);
